import * as React from "react";
import { forwardRef, memo } from "react";
const SvgNearMeOutlinedSmall = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 7.80764L13 3.0708L8.26316 13.0708L7.21053 8.86027L3 7.80764Z", stroke: "currentColor", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgNearMeOutlinedSmall);
const Memo = memo(ForwardRef);
export default Memo;
